import { render, staticRenderFns } from "./orderTab.vue?vue&type=template&id=5aee6560&scoped=true"
import script from "./orderTab.vue?vue&type=script&lang=js"
export * from "./orderTab.vue?vue&type=script&lang=js"
import style0 from "./orderTab.vue?vue&type=style&index=0&id=5aee6560&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aee6560",
  null
  
)

export default component.exports